import React from "react";
import { Divider } from "@material-ui/core";
import Container from "@material-ui/core/Container";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Helmet } from "react-helmet";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import Error from "../../../components/Error";
import Loading from "../../../components/Loading";
import { endOfTitle } from "../../../constants/constants";
import { ExtraDocumentsWidget } from "../../program/components/ViewMorePage/ExtraDocumentsWidget";
import { ViewMoreDetailsWidget } from "../../program/components/ViewMorePage/ViewMoreDetailsWidget";
import { OperatingCountriesWidget } from "../components/ViewMorePage/OperatingCountriesWidget";
import { ViewMoreSubInfoWidget } from "../components/ViewMorePage/ViewMoreSubInfoWidget";
import { parseViewMoreServiceToFrontEndModel } from "../helpers/parseServicesToFrontEndModel";
import useServicesQueries from "../hooks/useServicesQueries";
import { ServiceProviderInfoWidget } from "../components/ViewMorePage/ServiceProviderInfoWidget";

const useStyles = makeStyles(() => ({
  main: {
    display: "flex",
    justifyContent: "center",
  },
  root: {
    width: 1144,
    border: "1px solid #e8eaf0",
    background: "#FFFFFF",
    boxShadow: "0px 0px 8px #C2C9D6",
    borderRadius: 15,
  },
  content: {
    padding: "16px 32px 32px",
  },
  divider: {
    backgroundColor: "#DBDBDB",
  },
  subContainer: {
    marginTop: 42,
  },
  extraDocumentsContainer: {
    marginTop: 56,
  },
  applyButtonContainer: {
    marginTop: 48,
    marginBottom: 42,
    display: "flex",
    justifyContent: "right",
  },
  applyButton: {
    width: 235,
    height: 44,
  },
}));

export const ServicesViewMorePage = () => {
  const classes = useStyles();

  const params: { id: string; educationType: string } = useParams(); //TODO HA correct educationType
  const { fetchViewMore } = useServicesQueries();
  const { isLoading, data: service } = useQuery(`${params.id}`, async () => {
    const response = await fetchViewMore(params.id);
    return parseViewMoreServiceToFrontEndModel(response.data);
  });

  if (isLoading) {
    return <Loading />;
  }

  return (
    <Container maxWidth="lg" className={classes.main}>
      <Helmet>
        <title>View More{endOfTitle}</title>
      </Helmet>
      {!service ? (
        <Error text={"The service was not found"} />
      ) : (
        <div className={classes.root}>
          <ServiceProviderInfoWidget
            serviceId={service.id}
            serviceProviderId={service.serviceProvider.id}
            name={service.serviceProvider.name}
            image={service.serviceProvider.image}
          />
          <Divider className={classes.divider} />
          <div className={classes.content}>
            <ViewMoreSubInfoWidget
              country={service.serviceProvider.country}
              serviceType={service.serviceTypeName}
            />
            <div className={classes.subContainer}>
              <OperatingCountriesWidget countries={service.countries} />
            </div>

            <div className={classes.subContainer}>
              <ViewMoreDetailsWidget
                programDetails={service.details}
                title="Service Details"
              />
            </div>
            {!!service.extraDocuments?.length && (
              <div className={classes.extraDocumentsContainer}>
                <ExtraDocumentsWidget extraDocuments={service.extraDocuments} />
              </div>
            )}
          </div>
        </div>
      )}
    </Container>
  );
};
